/* eslint-disable no-underscore-dangle */
import L from 'leaflet';
import 'mapbox-gl';
import 'mapbox-gl-leaflet';

/**
 * Custom MapBoxGL that sets the layer on the right pane and with the right opacity.
 */
const CustomMapBoxGL = L.MapboxGL.extend({
  options: {
    updateInterval: 32,
    padding: 0.1,
    interactive: false,
    pane: 'overlayPane',
    attribution: null
  },

  onAdd(map) {
    if (!this._container) {
      this._initContainer();
    }
    map.getPane(this.options.pane).appendChild(this._container);
    this._initGL();
    this._offset = this._map.containerPointToLayerPoint([0, 0]);
    if (map.options.zoomAnimation) {
      L.DomEvent.on(map._proxy, L.DomUtil.TRANSITION_END, this._transitionEnd, this);
    }
  },

  onRemove(map) {
    if (this._map._proxy && this._map.options.zoomAnimation) {
      L.DomEvent.off(this._map._proxy, L.DomUtil.TRANSITION_END, this._transitionEnd, this);
    }
    map.getPane(this.options.pane).removeChild(this._container);
    this._glMap.remove();
    this._glMap = null;
  },

  _initContainer() {
    const container = L.DomUtil.create('div', 'leaflet-gl-layer');
    this._container = container;

    const size = this.getSize();
    const offset = this._map.getSize().multiplyBy(this.options.padding);
    container.style.width = `${size.x}px`;
    container.style.height = `${size.y}px`;
    if (this.options.opacity < 1) {
      container.style.opacity = this.options.opacity;
    }

    const topLeft = this._map.containerPointToLayerPoint([0, 0]).subtract(offset);

    L.DomUtil.setPosition(container, topLeft);
  }
});

const customMapBoxGL = opts => new CustomMapBoxGL(opts);

export default customMapBoxGL;
